import React from "react";
import { Link } from "react-router-dom";
import backimg from '../assets/solutions-images/hero_ban_about.webp';
const About = () => {
    return (
        <>
            <div>
                <div
                    className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-center px-6 py-16 md:px-8 lg:px-16 hover_herosec"
                    style={{ backgroundImage: `url(${backimg})` }}
                >
                    <h1 style={{ wordSpacing: '8px' }} data-aos="fade-down" className="text-xl md:text-3xl lg:text-5xl font-semibold text-white w-full sm:w-full md:w-2/3 lg:w-2/3">
                        We're driving the Digital transformation of the workplace
                    </h1>
                    <p className="text-white text-sm max-w-[640px]" data-aos="fade-down">
                        In today's competitive digital landscape, businesses need a solid foundation, adaptable framework, and operational agility to succeed.  Our deep experience in management consulting has shown us the transformative power of the ServiceNow platform for digital operations. We specialize in leveraging its solution workflows to streamline and optimize your digital processes.
                    </p>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="200"
                        to="/contact-us"
                        className="w-[100px] w-fit sm:w-[150px] md:w-[140px] text-semibold lg:w-[150px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white  hover:bg-white hover:text-[#C32A7C] transition-colors duration-400 ease-in-out text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
            <div className="bg-[#FFFFFF] mt-6">

                <div className="flex flex-col sm:justify-center text-center items-center gap-4 py-8 px-4">
                    <h1 className="text-[#1A5298] font-bold text-lg md:text-3xl ">
                        Why us vs. the other guy?
                    </h1>
                </div>

                <div className="bg-white mb-10">
                    <div data-aos="zoom-in-up" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-10 px-4 md:px-10 lg:px-10 py-5 items-start">
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold max-w-[253px] text-center">We are product specialists.</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[361px]">
                                We're not just about invoices; we're about solutions.  Our team's extensive system expertise allows us to provide personalized recommendations tailored to your needs, even if that means rethinking your current processes.
                            </p>
                        </div>
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold max-w-[253px] text-center">We're an extension of your team.</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[361px]">
                                We collaborate closely with your team to streamline internal processes, identify growth opportunities, and implement flexible, proven solutions that solve your business challenges.
                            </p>
                        </div>
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold max-w-[243px] text-center">We’re not a "one-size fits all” approach.</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-center max-w-[361px]">
                                While we rely on our experience to incorporate best practices and insights from past projects, our focus is finding the solutions that best align with your unique objectives and yield tangible results.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-[#FFFFFF] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6">

                    <h1 className="line_heightsests text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-5 w-full md:w-2/2 lg:w-2/3">
                        Experience the Tekpossible difference
                    </h1>
                    <h5 className="text-md text-black mb-10 font-medium text-center max-w-[1000px]" data-aos="zoom-in-up">With decades of experience, deep industry expertise, and a steadfast commitment to client success, Tekpossible is the perfect partner for businesses seeking to unlock the full potential of their ServiceNow investment.</h5>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="200"
                        to={"/contact-us"}
                        className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold 
                        hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                        text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
        </>
    );
}

export default About;